import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["link"];
import Link from "next/link";
import { useSliderPosition } from "@/hooks";
import styles from "@/styles/Card.module.scss";
import { useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LoadMoreCard(_ref) {
  var link = _ref.link,
      props = _objectWithoutProperties(_ref, _excluded);

  var cardRef = useRef();
  var classNames = useSliderPosition(props, cardRef);
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    className: classNames,
    children: /*#__PURE__*/_jsx(Link, {
      href: link.href,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.loadMoreContainer,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.loadMore,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.loadMoreInner,
            children: [/*#__PURE__*/_jsxs("span", {
              className: styles.icon,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.dot
              }), /*#__PURE__*/_jsx("span", {
                className: styles.dot
              }), /*#__PURE__*/_jsx("span", {
                className: styles.dot
              })]
            }), /*#__PURE__*/_jsx("span", {
              children: "\u3082\u3063\u3068\u898B\u308B"
            })]
          })
        })
      })
    })
  });
}